import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import year23 from "../assets/images/2024.png";
import year20 from "../assets/images/2023.png";
import year19 from "../assets/images/2022.png";
import year18 from "../assets/images/2020.png";
import year17 from "../assets/images/2018.png";
import asta from "../assets/images/showmelocal-trp.png";

const AchievementsSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    updateIsMobile(); // Initial check
    window.addEventListener("resize", updateIsMobile);

    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true, // Enable automatic scrolling
    autoplaySpeed: 2000,
  };

  return (
    <section>
      <Container>
        <Row>
          <Col lg="12">
            <div className="row" style={{ backgroundColor: "#ffffff" }}>
              {isMobile ? (
                <Slider {...settings}>
                  {[
                    { alt: "Traveller's Choice", src: year23 },
                    {
                      alt: "Traveller's Choice",
                      src: year20,
                      link: "https://www.tripadvisor.com/Attraction_Review-g304555-d10807588-Reviews-The_Rustic_Paths-Jaipur_Jaipur_District_Rajasthan.html",
                    },
                    {
                      alt: "Certificate of Excellence 2019",
                      src: year19,
                      link: "https://www.tripadvisor.com/Attraction_Review-g304555-d10807588-Reviews-The_Rustic_Paths-Jaipur_Jaipur_District_Rajasthan.html",
                    },
                    {
                      alt: "Certificate of Excellence 2018",
                      src: year18,
                      link: "https://www.tripadvisor.com/Attraction_Review-g304555-d10807588-Reviews-The_Rustic_Paths-Jaipur_Jaipur_District_Rajasthan.html",
                    },
                    {
                      alt: "Certificate of Excellence 2017",
                      src: year17,
                      link: "https://www.tripadvisor.com/Attraction_Review-g304555-d10807588-Reviews-The_Rustic_Paths-Jaipur_Jaipur_District_Rajasthan.html",
                    },
                    {
                      alt: "",
                      src: asta,
                      link: "/images/asta.jpg",
                    },
                  ].map((item, index) => (
                    <div key={index} className="col-lg-2">
                      {item.link ? (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            style={{
                              padding: "10px",
                              width: "100%",
                              borderRadius: "15px",
                              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                            alt={item.alt}
                            src={item.src}
                          />
                        </a>
                      ) : (
                        <img
                          style={{
                            padding: "10px",
                            width: "100%",
                            borderRadius: "15px",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                          }}
                          alt={item.alt}
                          src={item.src}
                        />
                      )}
                    </div>
                  ))}
                </Slider>
              ) : (
                <div
                  className="col-lg-12"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  {[
                    { alt: "Traveller's Choice", src: year23 },
                    {
                      alt: "Traveller's Choice",
                      src: year20,
                      link: "https://www.tripadvisor.com/Attraction_Review-g304555-d10807588-Reviews-The_Rustic_Paths-Jaipur_Jaipur_District_Rajasthan.html",
                    },
                    {
                      alt: "Certificate of Excellence 2019",
                      src: year19,
                      link: "https://www.tripadvisor.com/Attraction_Review-g304555-d10807588-Reviews-The_Rustic_Paths-Jaipur_Jaipur_District_Rajasthan.html",
                    },
                    {
                      alt: "Certificate of Excellence 2018",
                      src: year18,
                      link: "https://www.tripadvisor.com/Attraction_Review-g304555-d10807588-Reviews-The_Rustic_Paths-Jaipur_Jaipur_District_Rajasthan.html",
                    },
                    {
                      alt: "Certificate of Excellence 2017",
                      src: year17,
                      link: "https://www.tripadvisor.com/Attraction_Review-g304555-d10807588-Reviews-The_Rustic_Paths-Jaipur_Jaipur_District_Rajasthan.html",
                    },
                    {
                      alt: "",
                      src: asta,
                      link: "/",
                    },
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="d-inline-block"
                      style={{
                        width: "14%",
                        margin: "0 10px",
                      }}
                    >
                      {item.link ? (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            style={{
                              padding: "10px",
                              width: "100%",
                              borderRadius: "15px",
                              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                            alt={item.alt}
                            src={item.src}
                          />
                        </a>
                      ) : (
                        <img
                          style={{
                            padding: "10px",
                            width: "100%",
                            borderRadius: "15px",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                          }}
                          alt={item.alt}
                          src={item.src}
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AchievementsSection;
